import React, { memo } from "react";

interface IShieldIconProps {
  size?: number;
}
const ShieldIcon: React.FC<IShieldIconProps> = memo(({ size }) => {
  return (
    <svg
      width={size || 16}
      height={size || 16}
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.09094 3.40909L8.00003 0.5L14.9091 3.40909V7.77273C14.9091 11.8091 11.9612 15.5836 8.00003 16.5C4.03882 15.5836 1.09094 11.8091 1.09094 7.77273V3.40909ZM10.9005 5.79017L7.1156 9.76634L5.85126 8.41857C5.71469 8.28573 5.56037 8.2193 5.38832 8.2193C5.21625 8.2193 5.06714 8.28573 4.94098 8.41857C4.79853 8.56238 4.72731 8.72486 4.72731 8.90604C4.72731 9.08722 4.79559 9.24424 4.93215 9.37708L6.66384 11.2005C6.77961 11.3396 6.9302 11.4091 7.1156 11.4091C7.301 11.4091 7.45679 11.3396 7.58295 11.2005L11.802 6.74868C11.934 6.61584 12 6.45883 12 6.27764C12 6.09647 11.934 5.93398 11.802 5.79017C11.6654 5.65733 11.5126 5.59091 11.3434 5.59091C11.1743 5.59091 11.0267 5.65733 10.9005 5.79017Z"
        fill="currentColor"
      />
    </svg>
  );
});

export { ShieldIcon };
